import axios from 'axios'
import React, { useState, useEffect, useMemo, Fragment, useRef } from 'react'

import {
  FormControl,
  InputLabel,
  Input,
  FormHelperText,
  Alert,
  Paper,
} from '@mui/material'
import WebService from '@util/webService'
import {
  copyProperties,
  encodeParams,
  getAction,
  isStringNullOrEmpty,
  printVariable,
  searchCompany,
} from '@util/helper'
// redux
import { useSelector, useDispatch } from 'react-redux'
// MUI Table
import CssBaseline from '@mui/material/CssBaseline'
import MUITable from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableFooter from '@mui/material/TableFooter'
// react-table
import { useTable, useExpanded } from 'react-table'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import {
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography,
  Snackbar,
  TablePagination,
  TextField,
  withStyles,
  InputBase,
} from '@mui/material'
import { styled, alpha } from '@mui/material/styles'
import '@scss/App.scss'
import Button from '@mui/material/Button'
import FlatButton from '@components/FlatButton'
import useSnackbar from '@hooks/useSnackbar'
import MyTableHead from '@components/MyTableHead'
import useIndicator from '@hooks/useIndicator'
import Indicator from '@components/Indicator'
import MyDialog from '@components/MyDialog'
import Box from '@mui/material/Box'
import useAlert from '@hooks/useAlert'
// pagination
import { useTheme } from '@mui/material/styles'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight'
import LastPageIcon from '@mui/icons-material/LastPage'
import { Avatar, Grid, Container } from '@mui/material/'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import moment from 'moment'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import { searchSchool } from '@util/helper'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { useMediaQuery } from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import { setAccount } from '@redux/actions/accountAction';
import ConfirmDialog from '@components/ConfirmDialog'
import useDelegate from '@hooks/useDelegate'
const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined'
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined'
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import { setArgs } from '@craco/craco/dist/lib/args'
import consoleLogger from 'react-terminal-logger/console-logger'

const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`

const ProfileUserPartCareer = () => {
  const location = useLocation()
  console.log('location state=>', location)
  const dateFormat = 'YYYY-MM-DD HH:mm:ss'

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const defTerms = {}

  const [dataList, set_dataList] = useState([])
  const [openSnackbar, renderSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()
  const dgHandler = useState(false)
  const [terms, _set_terms] = useState(defTerms)
  const termsRef = useRef(terms)

  // redux
  const codeGroups = useSelector((state) => state.codeGroupReducer)
  const codes = useSelector((state) => state.codeReducer)
  const schools = useSelector((state) => state.schoolReducer)
  const account = useSelector((state) => state.accountReducer)

  const [record, set_record] = useState({})
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [career, set_career] = useState(location.state?.career ?? {})
  console.log('career==========>', career)
  const set_terms = (data) => {
    termsRef.current = data
    _set_terms(data)
  }

  useEffect(() => {
    // onLoad()
  }, [])

  const onLoad = async () => {
  }

  ////
  const onSubmit = async () => {
  }

  const validate = (name, value) => {
  }

  const onSave = () => {
    console.log('onSave career.companyName =>', career.companyName)
    if(career.companyName && career.companyName.length > 0) {
      const newAccount = {...account}
      if(!newAccount.user.careerList) {
        newAccount.user.careerList = []
      }
      newAccount.user.careerList.push(career) 
      dispatch(setAccount(newAccount))
      console.log('go back....')
      navigate(-1)
    }
    else {
      openSnackbar('기업명이 입력되지 않았습니다.')
    }
  }

  return (
    <Container component="main" maxWidth="md">
      {/* backward */}
      <Grid container spacing={2} style={{marginTop:10}}>
        <Grid item xs={12 }>
          <ArrowBackOutlinedIcon style={{cursor:'pointer'}}  onClick={() => navigate(-1)}/>
        </Grid>
      </Grid>

      <Grid item xs={12} style={{marginTop:10}}>
        <Typography variant="h5" style={{ fontWeight: 'bold' }}>
          경력 정보
        </Typography>
      </Grid>
      {/*  */}
      <Grid container spacing={2} style={{marginTop:10}}>
        <Grid item xs={12}>
          <TextField fullWidth label='기업명'
            value = {career.companyName}
            onChange={(e) => {
              career.companyName = e.target.value
              console.log('career.companyName =>', career.companyName)
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth label='직위'
            value={career.position}
            onChange={(e) => {
              career.position = e.target.value
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField fullWidth label='직무'
            value={career.position}
            onChange={(e) => {
              career.job = e.target.value
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox onChange={null} color="primary" />
            }
            label="현재 근무 중"
          />
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={1} style={{display:'flex', alignItems:'center'}}>
            <Grid item xs={2}>
              <Typography>시작 년월</Typography>
            </Grid>
            <Grid item xs={5}>
              <TextField fullWidth label='년'/>
            </Grid>
            <Grid item xs={5}>
              <TextField fullWidth label='월'/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={1} style={{display:'flex', alignItems:'center'}}>
            <Grid item xs={2}>
              <Typography>종료 년월</Typography>
            </Grid>
            <Grid item xs={5}>
              <TextField fullWidth label='년'/>
            </Grid>
            <Grid item xs={5}>
              <TextField fullWidth label='월'/>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          직무 설명
        </Grid>
        <Grid item xs={12}>
          <TextareaAutosize 
            style={{width:'100%'}}
            minRows={10}
            value={null}
          /> 
        </Grid>
      </Grid>

      {/* 저장 */}
      <Grid container spacing={2} style={{marginTop:20}}>
        <Grid item xs={12} style={{display:'flex', justifyContent:'flex-end'}}>
          <Button fullWidth size='large' variant='contained'
            onClick={onSave}
          >저장</Button>
        </Grid>
      </Grid>

      <div>
        {renderSnackbar()}
        {renderIndicator()}
        {renderAlert()}
      </div>
    </Container>
  )
}

export default ProfileUserPartCareer
